import React from 'react';
import { createRoot } from 'react-dom/client';
import './App.less';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AuthenticationWrapper from './AuthenticationWrapper';
import { LocalizationProvider } from '../services/localization/localization.service';
import { MonitoringProvider } from '../services/monitoring/MonitoringProvider';
import { registerEnquiryMutations } from '../services/enquiry/enquiry.service';
import { registerPublicBranchCalls } from '../services/branches/branches.service';
import { registerUserCalls } from '../services/users/users.service';
import { registerEditorCalls } from '../services/editor/editor.service';

// Initialize React Scan conditionally only when explicitly enabled
if (process.env.ENABLE_REACT_SCAN === 'true') {
  // Dynamic import to ensure react-scan is only loaded when needed
  import('react-scan')
    .then(({ scan }) => {
      console.log('React Scan enabled');
      scan({ enabled: true });
    })
    .catch((error) => {
      console.warn('Failed to load React Scan:', error);
    });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: Infinity,
    },
  },
});

registerEnquiryMutations(queryClient);
registerPublicBranchCalls(queryClient);
registerUserCalls(queryClient);
registerEditorCalls(queryClient);

// Create a component that wraps all providers
const App = () => (
  <LocalizationProvider>
    <QueryClientProvider client={queryClient}>
      <MonitoringProvider>
        <AuthenticationWrapper />
      </MonitoringProvider>
    </QueryClientProvider>
  </LocalizationProvider>
);

createRoot(document.getElementById('app')!).render(<App />);
